export const ActionTypes = {
  LOADING: "GET_OVERALL_PROGRESS_LOADING",
  ERROR: "GET_OVERALL_PROGRESS_ERROR",
  SUCCESS: "GET_OVERALL_PROGRESS_SUCCESS"
};
